import { render, staticRenderFns } from "./kCategoryIndex.vue?vue&type=template&id=ac03dad6&scoped=true"
import script from "./kCategoryIndex.vue?vue&type=script&lang=js"
export * from "./kCategoryIndex.vue?vue&type=script&lang=js"
import style0 from "./kCategoryIndex.vue?vue&type=style&index=0&id=ac03dad6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac03dad6",
  null
  
)

export default component.exports